import { createContext } from 'react';

export const context = createContext<{
  activeTab: string;
}>(undefined as any);
